import { gql } from "@apollo/client";

export const UPDATE_SECURITY_EMAIL = gql`
  mutation UpdateAccountSecurityEmail($securityEmail: String!) {
    accountUpdateSecurityEmail(securityEmail: $securityEmail)
  }
`;
